<template>
    <div class="autobooker-steps-container">
        <AutobookerStep v-for="step in steps" :key="step.id" :step="step" :active="activeStep === step.key" :retrying="retryingSteps.indexOf(step.id) !== -1 || step.status === 'RETRY_REQUESTED'"
                        @click="handleStepClick(step)" @close="handleStepClose(step)" @retry="handleStepRetry(step)"  />
    </div>
</template>
<script>
import AutobookerStep from './AutobookerStep';
import _ from 'lodash';

export default {
    name: 'AutobookerSteps',

    components: { AutobookerStep },

    data: () => ({
        activeStep: null,
        retryingSteps: []
    }),

    props: {
        steps: {
            type: Array,
            required: true
        }
    },

    computed: {
        step() {
            return (key) => _.find(this.steps, { key });
        }
    },

    methods: {
        handleStepClick(step) {
            if (this.activeStep === step.key) {
                return;
            }

            this.activeStep = step.key;
        },

        handleStepClose(step) {
            this.activeStep = null;
        },

        handleStepRetry(step) {
            this.retryingSteps.push(step.id)
            this.$emit('retryStep', step);
        }
    }
};
</script>
